module.exports = __webpack_public_path__ + "images/emoji/suspension_railway.ffbca9cd6a3b6e01f204.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/suspension_railway.png
// module id = SuqG
// module chunks = 1